/* eslint-disable import/no-cycle,no-param-reassign */
import Vue from 'vue';
import FavCellsService from '@/services/favCells.service';
import {
  FETCH_FAV_CELL,
} from '../../../../actions.type';
import {
  FETCH_FAV_CELL_SUCCESS,
} from '../../../../mutations.type';

export default {
  state: {
    favCellData: {},
  },
  getters: {
    favCellData(state) {
      return state.favCellData;
    },
  },
  mutations: {
    [FETCH_FAV_CELL_SUCCESS](state, data) {
      Vue.set(state, 'favCellData', data.favCell);
    },
  },
  actions: {
    [FETCH_FAV_CELL](context, id) {
      return new Promise((resolve, reject) => {
        FavCellsService.get(id)
          .then((response) => {
            context.commit(FETCH_FAV_CELL_SUCCESS, response.data.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
